import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        buttonHeader: {
            backgroundColor: theme.palette.primary[500],
            height: 161,
        },
    }
})
